import { cloneDeep, last, sortBy } from 'lodash'
import { ToastProgrammatic as Toast } from 'buefy'

const defaultState = {
  current: null,
  isSubmitting: false,
  currentPayment: null
}

export const state = () => cloneDeep(defaultState)

export const getters = {
  current(state) {
    return state.current
  },
  isCanceledOrExpired(state) {
    return (
      // Needs a better way to identify when membership is print pending
      // state.current?.status === 'completed' ||
      state.current?.status === 'canceled' || state.current?.status === 'expired'
    )
  },
  isSubmitting(state) {
    return state.isSubmitting
  },
  currentPayment(state) {
    return state.currentPayment
  }
}

export const mutations = {
  current(state, current) {
    state.current = current
  },
  isSubmitting(state, isSubmitting) {
    state.isSubmitting = isSubmitting
  },
  currentPayment(state, currentPayment) {
    state.currentPayment = currentPayment
  }
}

export const actions = {
  async getById({ commit }, id) {
    const result = await this.$coreApi.$get(`staff/memberships/${id}`)
    commit('current', result.data)
  },

  async reject({ commit }, { id, form, federation }) {
    await this.$coreApi
      .$post(`staff/memberships/${id}/reject`, form)
      .then(() => {
        commit('current', null)

        this.$router.push(
          this.app.localePath({
            name: 'admin-memberships',
            query: { status: 'staff_approval', sort: '-created_at', federation }
          })
        )

        Toast.open({
          duration: 5000,
          message: translations[this.$i18n.locale].rejectSuccess,
          position: 'is-top',
          type: 'is-success'
        })
      })
      .catch(error => {
        Toast.open({
          duration: 5000,
          message: this.$formatServerError(error, 'errors'),
          position: 'is-top',
          type: 'is-danger'
        })
      })
  },
  solicitateAdditionalDocument({ commit, dispatch }, { id, type }) {
    commit('isSubmitting', true)

    this.$coreApi
      .$post(`staff/memberships/${id}/solicitate_additional_document`, { type })
      .then(() => {
        dispatch('getById', id)
      })
      .catch(error => {
        Toast.open({
          duration: 5000,
          message: this.$formatServerError(error, 'errors'),
          position: 'is-top',
          type: 'is-danger'
        })
      })
      .finally(() => commit('isSubmitting', false))
  },

  includeApprovedDocument({ commit, dispatch }, { id, type, subtype, files }) {
    commit('isSubmitting', true)

    this.$coreApi
      .$post(`staff/memberships/${id}/include_approved_document`, { type, subtype, files })
      .then(() => {
        dispatch('getById', id)
      })
      .catch(error => {
        Toast.open({
          duration: 5000,
          message: this.$formatServerError(error, 'errors'),
          position: 'is-top',
          type: 'is-danger'
        })
      })
      .finally(() => commit('isSubmitting', false))
  },

  async getMembershipPayments({ commit, dispatch }, membershipId) {
    commit('currentPayment', null)

    const paymentsList = await this.$nodeApi.$get(`admin/athletes/memberships/payments`, {
      params: {
        requestReferenceId: membershipId
      }
    })

    if (paymentsList.list.length) {
      const lastPaymentId = +last(sortBy(paymentsList.list, 'id')).id
      const result = await this.$nodeApi.$get(
        `admin/athletes/memberships/payments/${lastPaymentId}`
      )
      commit('currentPayment', result)
    } else {
      /*
       * If we don't find the payment by requestReferenceId, we try to find it by legacyRequestReferenceId
       * This adds support for displaying the payment page for a legacy memberships (Requests were not migrated to the new model)
       * It's not pretty, but it works for historical purposes (at least for now)
       * The call to getByLegacyRequestReferenceId is made here to minimize changes to the WebUI pages and Nest API.
       */
      const filters = {
        legacyRequestReferenceId: membershipId,
        legacyRequestReferenceType: 'Ibjjf.Lib.Athletes.Domain.Membership',
        requestType: null,
        requestReferenceId: null
      }

      await dispatch('getByLegacyRequestReferenceId', filters)
    }
  },
  async getByLegacyRequestReferenceId({ commit }, filters) {
    const paymentsList = await this.$nodeApi.$get(`admin/athletes/memberships/payments`, {
      params: filters
    })

    if (paymentsList.list.length) {
      const lastPaymentId = +last(sortBy(paymentsList.list, 'id')).id
      const result = await this.$nodeApi.$get(
        `admin/athletes/memberships/payments/${lastPaymentId}`
      )
      commit('currentPayment', result)
    }
  }
}

export const translations = {
  'en-US': {
    rejectSuccess: 'Membership canceled successfully.'
  },
  'pt-BR': {
    rejectSuccess: 'Solicitação cancelada com sucesso.'
  }
}
